import axios from "./config";

/**
 * Fetch the prefill for the send alert modal
 *
 * @function
 * @name getAlertTemplate
 *
 * @param {Object} params - project_id, council_id, report_start_date, report_end_date
 * @returns {Promise}
 */
const getAlertTemplate = (params = {}) => {
  return axios
    .get(`/alerts/template`, { params: { type: "report-submission", ...params } })
    .then((response) => response.data);
};

/**
 * Send one alert for a council
 *
 * @function
 * @name sendAlert
 *
 * @param {Object} payload - project_id, council_id, period, title, description,
 *                           to_emails, cc_emails, bcc_emails, save_as_default
 * @returns {Promise}
 */
const sendAlert = (payload = {}) => {
  return axios
    .post(`/alerts/send`, payload, { params: { type: "report-submission" } })
    .then((response) => response.data);
};

export default {
  getAlertTemplate,
  sendAlert,
};
